import "antd/dist/antd.css";
import React, { useLayoutEffect } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import Checkout from "./components/Checkout";
import Home from "./components/Home";
import Login from "./components/Login";
import Register from "./components/Register";
import Search from "./components/Search";
import Thanks from "./components/Thanks";
import ipConfig from "./ipConfig.json";

export const config = {
  endpoint: 'https://qkart-search.herokuapp.com/api/v1',
};

export default function App(props) {
  const location = useLocation();
  // Scroll to top if path changes
  useLayoutEffect(() => {
    window && window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="App">
        {/* TODO: CRIO_TASK_MODULE_UNDERSTANDING_BASICS - To add route for /register */}

        {/* TODO: CRIO_TASK_MODULE_UNDERSTANDING_BASICS - To add route for /login */}
        <Switch>
          <Route path = '/register' component = {Register} />
          <Route path = '/login' component = {Login} />
          <Route path = "/products" component = {Search} />
          <Route path="/checkout" component = {Checkout} />
          <Route path="/thanks" component = {Thanks} />
          <Route path ='/'  component = {Home} />
        </Switch>
        

    </div>
  );
}
